<script>
export default {

    mounted() {
        this.content()
    },

    methods: {
        content() {            
            this.getItems(this.url)
        },
        getItems(url) {
            axios.get(url).then(this.refresh)
        },
        refresh({data}) {            
            this.data = data.data
        },
    }

}
</script>
